import { Checkbox } from '@components/Checkbox';
import { GrillIcon } from '@src/assets';
import React from 'react';
import { Chip } from './Chip';
import * as styled from './styled/AmenitiesGroup.styled';
import { CheckboxGroup } from './styled/CheckboxGroup.styled';
import { TitleGroup } from './TitleGroup';

export const AmenitiesGroup: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
    return (
        <styled.AmenitiesGroup>
            <TitleGroup
                title="Amenities"
                Icon={GrillIcon}
                Chip={<Chip label="optional" variant="caution" />}
            />
            <CheckboxGroup>
                <Checkbox disabled={disabled} name="hasPrivatePool" label="Private pool" />
                <Checkbox disabled={disabled} name="has_private_hot_tub" label="Private hot tub" />
                <Checkbox disabled={disabled} name="hasOven" label="Full kitchen" />
                <Checkbox disabled={disabled} name="has_gas_grill" label="Gas grill" />
                <Checkbox disabled={disabled} name="has_washerdryer" label="Washer dryer" />
                <Checkbox disabled={disabled} name="has_gas_fireplace" label="Gas fireplace" />
            </CheckboxGroup>
        </styled.AmenitiesGroup>
    );
};
